//REACT
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

//MUI 
import Grid from '@mui/material/Grid';
import { IconButton, useMediaQuery } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

//LIBRARY
import MainCard from '../../UI/MainCard';
import { DEFAULT_THEME, useThemes } from '../../utils/useThemes';
import CustomDataGrid from '../../UI/CustomDataGrid';
import { setMessageAndButtonText, hidePopup } from "../../redux/popup"
import NavigationPanel from '../../UI/NavigationPanel';
import { ROUTES, TRACKING_TYPES } from '../../utils/constants';
import TrackingService from '../../services/TrackingService';
import YellowButton from '../../UI/YellowButton';
import EditIcon from '@mui/icons-material/Edit';
import dayjs from 'dayjs';

const CardlessEmployeeTracking = () => {

    //snackbar functions
    const getTheme = useThemes()
    const isPhone = useMediaQuery(getTheme().breakpoints.down('phone'));
    const navigate = useNavigate()
    const { t } = useTranslation();
    const [panels, setPanels] = useState([t('adminPanel'), t('editCardlessEmployee')])

    const dispatch = useDispatch();
    const darkMode = useSelector(state => state.darkMode)
    const [page, setPage] = useState(0);

    const [limit, setLimit] = useState(8);
    const [params, setParams] = useState({ page, limit, trackingType: TRACKING_TYPES.EMPLOYEE });
    const [totalCount, setTotalCount] = useState(0)
    const [rows, setRows] = useState([]);
    const trackingService = new TrackingService()

    // service call for appointments with pagination
    const getTrackings = async (params) => {
        const response = await trackingService.getTrackings(params);
        if (response && response.data) {
            setRows(response.data)
            setTotalCount(response.count)
        }
    }

    const styles = {
        topGrid: {
            p: 4,
            backgroundColor: darkMode ? 'black' : 'white',
            borderWidth: '1px',
            borderRadius: '30px',
            borderStyle: 'solid',
            backdropFilter: 'blur(12px)',
            justifyContent: 'space-around',
            width: 'stretch',
            //height: '300px',
            borderColor: '#E3E5EA',
            //boxShadow: "1px 2px #84868B"

        },
        subtitle: {
            backgroundColor: darkMode ? 'black' : 'white',
            backdropFilter: 'blur(12px)',
            alignItems: 'center',
            borderStyle: 'solid',
            borderColor: '#EAEEF7',
            height: isPhone ? '120px' : '85px',
            borderRadius: 10,
            p: 2,
        },
        bottomGrid: {
            p: 4,
            backgroundColor: darkMode ? 'black' : 'white',
            borderWidth: '1px',
            borderRadius: '30px',
            borderStyle: 'solid',
            backdropFilter: 'blur(12px)',
            justifyContent: 'space-around',
            width: 'stretch',
            borderColor: '#E3E5EA',
            mt: '1rem'
        },
        strongText: {
            fontFamily: DEFAULT_THEME.typography.fontFamilyRegular,
            fontWeight: DEFAULT_THEME.typography.fontWeight.extra_bold,
            fontSize: DEFAULT_THEME.typography.fontSize.regular
        },
        lightText: {
            fontFamily: DEFAULT_THEME.typography.fontFamilyRegular,
            fontWeight: DEFAULT_THEME.typography.fontWeight.regular,
            fontSize: DEFAULT_THEME.typography.fontSize.light
        },

    }
    const deleteRow = async (object) => {
        const result = await trackingService.deleteTracking(object.id)

        if (result) {
            const newRows = rows.filter((row) => row.id !== object.id);
            setRows(newRows);
        }
    };
    {/* function to allow us to do a operation for particular row in this case is a delete and edit operation */ }
    const getActionColumnDetail = (object) => {
        return (
            <Grid container item justifyContent={"space-evenly"}>
                <Grid item>
                    <IconButton
                        title={t('edit')}
                        style={{
                            color: '#2980b9'
                        }}
                        onClick={() => navigate(ROUTES.CARDLESS_EMPLOYEE_ADD_OR_EDIT, { state: { request: object, isUpdate: true } })}
                    >
                        <EditIcon />
                    </IconButton>
                </Grid>
                <Grid item>
                    <IconButton
                        aria-label="delete"
                        title={t('delete')}
                        style={{
                            color: '#E45B5B'
                        }}
                        onClick={() => dispatch(setMessageAndButtonText({
                            'title': t("deleteTitle"),
                            'text': t("deleteText"),
                            'noButtonText': t("commonCancelButton"),
                            noButtonAction: () => {
                                dispatch(hidePopup())
                            },
                            'yesButtonText': t("commonDelete"),
                            yesButtonAction: () => {
                                deleteRow(object);
                                dispatch(hidePopup())
                            },
                            "isErrorMessage": false
                        }))}
                    >
                        <DeleteIcon />
                    </IconButton>
                </Grid>

            </Grid>

        );
    };
    const getActionColumn = (object) => {
        return (
            <Grid item>
                <YellowButton

                    style={{
                        height: '30px', width: '110px', borderRadius: 5, fontSize: 11
                    }}
                    onClick={() => {
                        dispatch(setMessageAndButtonText({
                            'title': 'Açıklama', 'noButtonText': t("commonHideButton"), noButtonAction: () => { dispatch(hidePopup()) }, 'text': object.description, "isErrorMessage": true
                        }))
                    }}>
                    {t('commonShowDescription')}
                </YellowButton>

            </Grid>
        );
    };
    //örnek column oluşturma
    const columns = [
        {
            field: 'operation',
            headerName: 'İşlem ',
            minWidth: 100,
            renderCell: (params) => getActionColumnDetail(params.row)
        },
        {
            field: 'trackingDate',
            headerName: 'Tarih',
            minWidth: 180,
            renderCell: (params) => dayjs(params.row.trackingDate, 'DD-MM-YYYY').format('DD/MM/YYYY')
        },
        {
            field: 'cardNumber',
            headerName: "Kart No",
            minWidth: 100,
            renderCell: (params) => params.row.employeeTracking?.cardNumber

        },
        {
            field: 'fullName',
            headerName: t('firstName2'),
            minWidth: 200,
            renderCell: (params) => params.row.employeeTracking?.fullName
        },
        {
            field: 'entranceTime',
            headerName: t('entranceTime'),
            minWidth: 180,
            renderCell: (params) => params.row.entranceTime?.slice(0, 5)
        },
        {
            field: 'exitTime',
            headerName: t('exitTimeLabel'),
            minWidth: 180,
            renderCell: (params) => params.row.exitTime?.slice(0, 5)
        },
        {
            field: 'details',
            headerName: 'Detay ',
            minWidth: 150,
            renderCell: (params) => getActionColumn(params.row)
        },


    ];
    return (

        <MainCard>

            {/* ********************************************************************** */}
            {/* NAVİGE PANEL*/}
            {/* ********************************************************************** */}
            <Grid container item xs={12} sx={{ ...styles.subtitle }}>
                <NavigationPanel panels={panels}></NavigationPanel>
            </Grid>

            <Grid item container sx={{ ...styles.bottomGrid }} justifyContent='space-between'>

                {/* ********************************************************************** */}
                {/* DATAGRID*/}
                {/* ********************************************************************** */}
                <Grid container item sx={{ mt: isPhone ? '1.5rem' : '' }}>
                    <CustomDataGrid
                        rows={rows}
                        columns={columns}
                        showFilterBar={true}
                        titleOfTable={t('cardlessEmployees')}
                        getFunction={getTrackings}
                        totalCount={totalCount}
                        params={params}

                    />
                </Grid>
            </Grid>
        </MainCard >


    );
}

export default CardlessEmployeeTracking